import { defaultStoreUtils } from '@databases/redux';

import { selectCollabManagerByContentId } from '../redux/collab/selectors';

export const useCollabManager = (contentId: string | null) => {
  if (contentId) {
    return defaultStoreUtils.useSelector((state) =>
      selectCollabManagerByContentId(state, { contentId })
    );
  }

  return undefined;
};
